// extracted by mini-css-extract-plugin
module.exports = {"blockImageMargin":"blockImageMargin-module--blockImageMargin--IGrEO"};